import { createSlice } from '@reduxjs/toolkit';

export const uiSlice = createSlice({
    name: 'ui',
    initialState: {
        isWebp: false,
        loadImages: false,
        activePage: null,
        wrapperHeight: null,
    },
    reducers: {
        setWebp: (state, action) => {
            state.isWebp = action.payload;
            state.loadImages = true;
        },
        setActivePage: (state, action) => {
            state.activePage = action.payload;
        },
        setWrapperHeight: (state, action) => {
            state.wrapperHeight = action.payload;
        },
    },
});

export const { setWebp, setActivePage, setWrapperHeight } = uiSlice.actions;

export const selectWebp = state => state.ui.isWebp;
export const selectLoad = state => state.ui.loadImages;
export const selectActivePage = state => state.ui.activePage;
export const selectWrapperHeight = state => state.ui.wrapperHeight;

export default uiSlice.reducer;